import React, { useState } from 'react';
import { authService } from '../services/api';
import { usuarioPodeAcessarConsulta } from '../utils/loginAccess';
import '../styles/Login.css';

const Login = ({ onLoginSuccess }) => {
  const [usuario, setUsuario] = useState('');
  const [senha, setSenha] = useState('');
  const [lembrar, setLembrar] = useState(false);
  const [erro, setErro] = useState('');
  const [carregando, setCarregando] = useState(false);
  const [verSenha, setVerSenha] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (carregando) return;

    setErro('');
    setCarregando(true);

    try {
      const response = await authService.login(usuario, senha, lembrar);

      if (response.status === 'sucesso') {
        const me = await authService.me();
        if (me?.status === 'sucesso' && me.usuario) {
          if (!usuarioPodeAcessarConsulta(me.usuario)) {
            await authService.logout();
            setErro('Acesso temporariamente restrito para este usuário.');
            return;
          }
          onLoginSuccess(me.usuario);
          return;
        }

        if (response.usuario) {
          if (!usuarioPodeAcessarConsulta(response.usuario)) {
            await authService.logout();
            setErro('Acesso temporariamente restrito para este usuário.');
            return;
          }
          onLoginSuccess(response.usuario);
          return;
        }

        setErro('Login realizado, mas não foi possível carregar o perfil.');
      } else if (response.status && response.mensagem) {
        setErro(response.mensagem);
      } else {
        setErro(response.mensagem || 'Erro ao fazer login');
      }
    } catch (error) {
      console.error('Erro no login:', error);
      setErro('Erro ao conectar com o servidor');
    } finally {
      setCarregando(false);
    }
  };

  const handlePasswordKeyDown = (e) => {
    if (e.key !== 'Enter' || e.nativeEvent?.isComposing) return;

    e.preventDefault();
    if (!carregando) e.currentTarget.form?.requestSubmit();
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <div className="login-header">
          <img src="/favicon.png" alt="seeLL" className="login-logo" />
          <h1>Acessar consultas</h1>
          <p>Entre com suas credenciais</p>
        </div>

        <form onSubmit={handleSubmit} className="login-form">
          {erro && (
            <div className="login-error">
              <i className="fas fa-exclamation-circle"></i>
              {erro}
            </div>
          )}

          {/* Campos agrupados num bloco só (padrão lista do iOS): o ícone faz o
              papel do rótulo e o fio separa os dois. */}
          <div className="login-fields">
            <div className="login-field">
              <i className="fas fa-user" aria-hidden="true"></i>
              <input
                type="text"
                id="usuario"
                value={usuario}
                onChange={(e) => setUsuario(e.target.value)}
                placeholder="Usuário ou CPF"
                aria-label="Usuário ou CPF"
                required
                autoFocus
                autoComplete="username"
              />
            </div>

            <div className="login-field">
              <i className="fas fa-lock" aria-hidden="true"></i>
              <input
                type={verSenha ? 'text' : 'password'}
                id="senha"
                value={senha}
                onChange={(e) => setSenha(e.target.value)}
                placeholder="Senha"
                aria-label="Senha"
                required
                autoComplete="current-password"
                enterKeyHint="go"
                onKeyDown={handlePasswordKeyDown}
              />
              <button
                type="button"
                className="login-reveal"
                onClick={() => setVerSenha((v) => !v)}
                aria-label={verSenha ? 'Ocultar senha' : 'Mostrar senha'}
                title={verSenha ? 'Ocultar senha' : 'Mostrar senha'}
                tabIndex={-1}
              >
                <i className={`fas ${verSenha ? 'fa-eye-slash' : 'fa-eye'}`}></i>
              </button>
            </div>
          </div>

          <div className="login-checkbox">
            <label htmlFor="lembrar">Lembrar-me</label>
            <span className="login-switch">
              <input
                type="checkbox"
                id="lembrar"
                checked={lembrar}
                onChange={(e) => setLembrar(e.target.checked)}
              />
              <span className="login-switch-trilho" aria-hidden="true"></span>
            </span>
          </div>

          <button
            type="submit"
            className="login-button"
            disabled={carregando}
          >
            {carregando ? (
              <>
                <i className="fas fa-spinner fa-spin"></i>
                Entrando...
              </>
            ) : (
              'Entrar'
            )}
          </button>
        </form>

        <div className="login-footer">
          <p>Sistema de Gestão seeLL</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
